<div class="flex-column gap">
    @if (personScroll()) {
        <app-select-input
            id="personId"
            [form]="form"
            [infiniteScroll]="personScroll()"
            [label]="prefix + 'fields.searchPerson'"
            valueKey="id"
            labelKey="surname"
            filterBy="name,surname,alias,insuranceNumber"
            [showClear]="true"
        >
            <ng-template #item let-item>
                <div class="flex-column">
                    <span>{{ item | formatPerson }}</span>
                    @if (item.birthdate || item.insuranceNumber) {
                        <small>
                            {{ item.birthdate | date: 'd. M. y' }}
                            @if (item.birthdate && item.insuranceNumber) {
                                &middot;
                            }
                            {{ item.insuranceNumber }}
                        </small>
                    }
                </div>
            </ng-template>
            <ng-template #selectedItem let-item>
                {{ item | formatPerson }}
            </ng-template>
        </app-select-input>
    }

    <app-date-input id="dateFrom" [form]="form" [prefix]="prefix"></app-date-input>
</div>

<div #dialogFooter class="p-dialog-footer">
    <app-button
        [label]="prefix + 'actions.createNew'"
        [text]="true"
        icon="pi-user-plus"
        (clickEvent)="createNewPerson()"
    ></app-button>
    <app-cancel-button (clickEvent)="dialogRef.close()"></app-cancel-button>
    <app-save-button label="common.add" (clickEvent)="save($event)"></app-save-button>
</div>
